module.exports = __webpack_public_path__ + "static/media/mouth-large.b2392636.png";